import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var CardsContainer = styled.div.withConfig({
  displayName: "partials__CardsContainer",
  componentId: "sc-ngos4j-0"
})(["display:flex;justify-content:space-between;overflow-x:auto;overflow-y:hidden;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}"]);
export var CategoryCard = styled.div.withConfig({
  displayName: "partials__CategoryCard",
  componentId: "sc-ngos4j-1"
})(["display:flex;flex-direction:column;min-width:220px;padding:15px 10px;border-radius:", ";margin:0 5px;margin-bottom:20px;background-color:", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.accent1LL;
});
export var CategoryTitle = styled.span.withConfig({
  displayName: "partials__CategoryTitle",
  componentId: "sc-ngos4j-2"
})(["", ";font-weight:600;color:#000;"], getFont(0));
export var TwoColumns = styled.div.withConfig({
  displayName: "partials__TwoColumns",
  componentId: "sc-ngos4j-3"
})(["display:grid;grid-template-columns:3fr 1fr;width:100%;"]);
export var SelectContainer = styled.div.withConfig({
  displayName: "partials__SelectContainer",
  componentId: "sc-ngos4j-4"
})(["display:flex;align-items:flex-end;flex-direction:column;justify-content:space-between;min-width:85px;min-height:50px;"]);